<template>
  <footer class="k-footer">
    <div class="row">
<!--      <span class="badge18">-->
<!--        <span class="b18">18+</span>-->
<!--        <a href="https://www.jugendschutzprogramm.de/" target="_blank" rel="noopener" aria-label="Mit JusProg-Jugendschutzprogramm kompatibel" style="display:inline-flex;line-height:0">-->
<!--          <img :src="jusprog" alt="JusProg — jugendschutzprogramm.de" width="151" height="31" loading="lazy" style="display:block;height:26px;width:auto">-->
<!--        </a>-->
<!--      </span>-->
      <div class="legal">
        <a href="/impressum">Impressum</a>
        <a href="/agb">AGB</a>
        <a href="/datenschutz">Datenschutz</a>
        <a href="#" role="button" @click.prevent="reopenCookies">Cookie-Einstellungen</a>
      </div>
      <span>© {{ year }} We2Gether GmbH</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'KennenlernenFooter',
  data() {
    return {
      // jusprog: require('../../../../../images/viluu/landing-v2/badges/jusprog.png'),
      year: new Date().getFullYear(),
    };
  },
  methods: {
    reopenCookies() {
      this.$eventHub.$emit('viluu-cookie:reopen');
    },
  },
};
</script>
